/**
 * PlaceholderPage — pagina riusabile per sezioni non ancora implementate.
 *
 * Usato da Agenda, Pazienti, Piani, Fatturazione, Comunicazioni,
 * Statistiche, Impostazioni in PR3. Mantiene l'AppShell visibile
 * (sidebar/topbar/bottomtab) e renderizza solo un'EmptyState centrata
 * con icona grande grigia.
 */

import type { ReactNode } from 'react';
import { Card } from '@shared/components/ui/Card';
import { EmptyState } from '@shared/components/ui/EmptyState';
import { PageHeader } from '../../components/ui/PageHeader';

export interface PlaceholderPageProps {
  title: string;
  subtitle?: string;
  icon: string;
  /** Slot opzionale sotto il placeholder (es. DevToolsPanel in Impostazioni). */
  extra?: ReactNode;
}

export function PlaceholderPage({
  title,
  subtitle,
  icon,
  extra,
}: PlaceholderPageProps) {
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle} />
      <Card padded={false}>
        <EmptyState
          icon={icon}
          title="In arrivo"
          description="Questa sezione sarà disponibile in una prossima versione di DietaGest."
          size="lg"
        />
      </Card>
      {extra}
    </div>
  );
}
